import React from "react";
import { Breadcrumb, Menu } from "semantic-ui-react";

type SimpleBreadcrumbsProps = {
  onBack: Function;
  title: string;
  subtitle: string;
};
const SimpleBreadcrumbs = ({
  onBack,
  title,
  subtitle,
}: SimpleBreadcrumbsProps) => {
  return (
    <Menu stackable>
      <Menu.Item>
        <Breadcrumb>
          <Breadcrumb.Section link onClick={() => onBack()}>
            {title}
          </Breadcrumb.Section>
          <Breadcrumb.Divider />
          <Breadcrumb.Section>{subtitle}</Breadcrumb.Section>
        </Breadcrumb>
      </Menu.Item>
    </Menu>
  );
};

export default SimpleBreadcrumbs;
